import { useState, useEffect } from "react";
import Header from "../components/Header";
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ImageSelector from "../components/ImageSelector";
import { useUserData } from "../hooks/useUserData";
import SearchInfo from "../components/SearchInfo";
import { useTranslation } from "../context/I18nContext";
import { useNavigate } from "react-router-dom";

const HomeGuest = () => {
  const [selectedImage] = useState<string | null>(null);
  const [selectedFile] = useState<File | null>(null);
  const { fetchUserInfo } = useUserData();
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserInfo();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Header noPricing />

      <Container
        maxWidth="md"
        sx={{
          pt: { xs: 2, md: 3 },
          pb: { xs: 4, md: 6 },
          px: { xs: 2, sm: 3 },
        }}
      >
        {/* Hero */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="overline"
            sx={{
              color: "primary.main",
              letterSpacing: "0.14em",
              fontWeight: 600,
              fontSize: "0.68rem",
              fontFamily: '"Inter", sans-serif',
            }}
          >
            {t("home.biometric_label")}
          </Typography>
          <Typography
            variant="h3"
            sx={{
              mt: 1,
              fontFamily: '"Manrope", sans-serif',
              fontWeight: 800,
              letterSpacing: "-0.02em",
              lineHeight: 1.15,
            }}
          >
            {t("home.title")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              color: "text.secondary",
              maxWidth: 440,
              mx: "auto",
              lineHeight: 1.7,
              fontFamily: '"Inter", sans-serif',
            }}
          >
            {t("home.billion_faces")}
          </Typography>
        </Box>

        {/* Upload Card (disabled) */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            bgcolor: "background.paper",
            boxShadow: "0 20px 40px rgba(25,28,30,0.06)",
            opacity: 0.7,
            pointerEvents: "none",
          }}
        >
          <ImageSelector
            disabled
            selectedFile={selectedFile}
            setSelectedFile={() => {}}
            selectedImage={selectedImage}
            setSelectedImage={() => {}}
          />
        </Paper>

        {/* CTA */}
        <Box sx={{ mt: 3 }}>
          <Button
            endIcon={<LockOutlinedIcon />}
            variant="contained"
            onClick={() => navigate("/login")}
            fullWidth
            sx={{
              height: 52,
              borderRadius: 2,
              fontSize: "0.95rem",
              fontWeight: 700,
              fontFamily: '"Manrope", sans-serif',
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
              boxShadow: "0 8px 20px rgba(0,65,82,0.25)",
              "&:hover": {
                background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.main})`,
                boxShadow: "0 12px 28px rgba(0,65,82,0.35)",
              },
            }}
          >
            {t("home.login_to_search")}
          </Button>
          {/* <Typography
            variant="caption"
            sx={{
              display: "block",
              mt: 1.5,
              letterSpacing: "0.06em",
              color: "text.disabled",
              fontFamily: '"Inter", sans-serif',
              fontSize: "0.7rem",
            }}
          >
            {t("home.billion_faces")}
          </Typography> */}
        </Box>

        {/* Source cards */}
        <SearchInfo />
      </Container>
    </Box>
  );
};

export default HomeGuest;
